"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsExecutionStatusEnums = void 0;
var SearchResultsExecutionStatusEnums;
(function (SearchResultsExecutionStatusEnums) {
    SearchResultsExecutionStatusEnums["NONSENSE"] = "NONSENSE";
    SearchResultsExecutionStatusEnums["ALT_BRAND"] = "ALT_BRAND";
    SearchResultsExecutionStatusEnums["ALT_QUERIES"] = "ALT_QUERIES";
    SearchResultsExecutionStatusEnums["ALT_SPELL_UNCHANGED"] = "ALT_SPELL_UNCHANGED";
    SearchResultsExecutionStatusEnums["ALT_SPELL_CHANGED"] = "ALT_SPELL_CHANGED";
    SearchResultsExecutionStatusEnums["DEFAULT"] = "DEFAULT";
})(SearchResultsExecutionStatusEnums || (exports.SearchResultsExecutionStatusEnums = SearchResultsExecutionStatusEnums = {}));
//# sourceMappingURL=SearchResultsEnums.js.map